import { AxiosInstance } from 'axios';
import { BaseApi } from 'services/api/base-api';
import { ApiResult } from 'services/api/result.type';
import { GetLearningOutcomeHoursResponse } from './dto/learning-outcome-hours.dto';
import { GetNaceCompetencyHoursResponse } from './dto/nace-competency-hours.dto';
import { GetEntriesResponse } from './dto/entries.dto';
import { GetLeadershipPositionsResponse } from './dto/leadership-positions.dto';
import { GetSummaryResponse } from './dto/summary.dto';

export class CoCurricularApi extends BaseApi {
  public constructor(protected readonly api: AxiosInstance) {
    super();

    this.getLearningOutcomeHours = this.getLearningOutcomeHours.bind(this);
    this.getNaceCompetencyHours = this.getNaceCompetencyHours.bind(this);
    this.getEntries = this.getEntries.bind(this);
    this.getLeadershipPositions = this.getLeadershipPositions.bind(this);
    this.getSummary = this.getSummary.bind(this);
  }

  public async getLearningOutcomeHours(): ApiResult<GetLearningOutcomeHoursResponse> {
    return await this.get<GetLearningOutcomeHoursResponse>(
      '/co-curricular/learning-outcome-hours',
    );
  }

  public async getNaceCompetencyHours(): ApiResult<GetNaceCompetencyHoursResponse> {
    return await this.get<GetNaceCompetencyHoursResponse>(
      '/co-curricular/nace-competency-hours',
    );
  }

  public async getEntries(page: number): ApiResult<GetEntriesResponse> {
    return await this.get<GetEntriesResponse>('/co-curricular/entries', {
      params: { page },
    });
  }

  public async getLeadershipPositions(): ApiResult<GetLeadershipPositionsResponse> {
    return await this.get<GetLeadershipPositionsResponse>(
      '/co-curricular/leadership-positions',
    );
  }

  public async getSummary(): ApiResult<GetSummaryResponse> {
    return await this.get<GetSummaryResponse>('/co-curricular/summary');
  }
}
